import { eq } from '@art-suite/art-core-ts';
import {
  ExpressionMap,
  OptimizedValueExpressions,
  OptimizedValueExpressionsBase,
  OptimizedValueExpressionsWithJustScope,
  Scope,
} from '../OptimizedValueExpressions';
import { getSetValuesFromScanValues, getValueOrExpressionFromScanValue, ScanPart } from '../ScanRoot';
import { isCalculatableValue, ScanTemplatePart } from '../ScanTemplateRoot';

const getExpressionMapFromScanTemplatePart = (template: ScanTemplatePart): ExpressionMap | undefined => {
  const expressionMap: ExpressionMap = {};
  let hasCalculatableValues = false;

  // Iterate through the template values
  if (template.values) {
    for (const key in template.values) {
      const templateValue = template.values[key];
      if (isCalculatableValue(templateValue)) {
        expressionMap[key] = getValueOrExpressionFromScanValue(templateValue.value);
        hasCalculatableValues = true;
      }
    }
  }
  return hasCalculatableValues ? expressionMap : undefined;
};

export const getOptimizedValueExpressions = (
  template: ScanTemplatePart,
  scope: Scope,
  scanPart?: ScanPart,
  existingOptimizedValueExpressions?: OptimizedValueExpressionsBase,
): OptimizedValueExpressionsBase => {
  const expressionMap = getExpressionMapFromScanTemplatePart(template);

  if (expressionMap) {
    const setValues = scanPart ? getSetValuesFromScanValues(scanPart.values) : undefined;
    if (existingOptimizedValueExpressions) {
      const optimizedValueExpressions = existingOptimizedValueExpressions as OptimizedValueExpressions;
      if (
        eq(setValues, optimizedValueExpressions.setValues)
        && eq(scope, optimizedValueExpressions.scope)
        && eq(expressionMap, optimizedValueExpressions.expressionMap)
      ) return existingOptimizedValueExpressions;
    }
    return new OptimizedValueExpressions(expressionMap, scope, setValues);
  } else {
    if (existingOptimizedValueExpressions && eq(scope, existingOptimizedValueExpressions.scope)) return existingOptimizedValueExpressions;
    return new OptimizedValueExpressionsWithJustScope(scope);
  }
};
